import { useState } from "react";
import { DashboardVendedorFilters } from "../../../types/filter";
import { Filters } from "../Filters";
import { VendedoresList } from "./VendedoresLIst";

export function DashboardContainer() {

    const [filters, setFilters] = useState<DashboardVendedorFilters>({
        fechaInicial: new Date().toISOString().split("T")[0],
        fechaFinal: new Date().toISOString().split("T")[0],
        estatus: "",
        vendedores: "",
        tipoVendedor: ""
    })

    return (
        <div className="flex flex-col h-full w-full">
            <p className="font-semibold text-3xl">Dashboard de Vendedores</p>
            <Filters
                filters={filters}
                setFilters={setFilters}/>
            
            <VendedoresList
                filters={filters}/>
        </div>
    );

}